module.exports = __webpack_public_path__ + "img/pic_fangkuai.09356559.png";